import apolloWrapper from '@hoc/apolloWrapper';
import CanComplain from '@components/CanComplain';

import { useCanComplainQuery } from './queries/graphql.v3.generated';

type Props = {
  username: string;
  allowComplain: (allow: boolean) => void;
  setUserId: (userId: number | null) => void;
  productPage: boolean;
};

export const CanComplainContainer: React.FC<Props> = ({
  username,
  allowComplain,
  setUserId,
  productPage,
}) => {
  const { loading, data, error } = useCanComplainQuery({
    variables: { username },
    context: { batch: true },
  });

  if (loading || error || !data || !data.user) {
    return null;
  }

  return (
    <CanComplain
      canComplain={data.user.viewerCanComplain}
      allowComplain={allowComplain}
      userId={data.user.id}
      setUserId={setUserId}
      username={username}
      productPage={productPage}
    />
  );
};

export default apolloWrapper(CanComplainContainer);
